import { ServiceGroup, ServiceItem } from 'orderme-api-integration-client';
import { ITracker } from '../tracker';
import { createShoppingCartsClient } from '../../helpers/client';
import { isMarketingCookiesAccepted } from '../../helpers/cookiesConsentStorage';

export class InternalTracker implements ITracker {
  private readonly cartClient = createShoppingCartsClient();

  public identifyContact(): void {
    // Don't need to track
  }

  public trackPage(): void {
    // Don't need to track
  }

  public viewedProductsGroup(_serviceGroup: ServiceGroup, _productUrl: string): void {
    // Don't need to track
  }

  public viewedProduct(_serviceItem: ServiceItem, _productUrl: string): void {
    // Don't need to track
  }

  public startedCheckout(): void {
    if (!this.canTrack()) {
      return;
    }

    try {
      this.cartClient.startedCheckout();
    } catch (error) {
      console.error('InternalTracker: Error in startedCheckout:', error);
    }
  }

  public canTrack(): boolean {
    return isMarketingCookiesAccepted();
  }
}
